import React from 'react';
import { motion } from 'framer-motion';
import { photoMoments } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

export default function Gallery() {
  return (
    <div className="space-y-8">
      <header className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-800 tracking-tight">Moment Archive</h1>
          <p className="text-slate-500 mt-1 font-medium">High-resolution visual logs of daily crew life.</p>
        </div>
        <div className="flex gap-3 w-full md:w-auto">
          <button className="flex-1 md:flex-none p-3 bg-white border border-slate-100 rounded-2xl text-slate-400 hover:text-[#0047AB] transition-all shadow-sm hover:shadow-md">
            <SafeIcon icon="FiGrid" className="text-xl mx-auto" />
          </button>
          <button className="flex-[2] md:flex-none bg-[#0047AB] hover:bg-blue-800 text-white px-8 py-3 rounded-2xl font-black transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-3 uppercase text-xs tracking-widest hover:scale-[1.02] active:scale-[0.98]">
            <SafeIcon icon="FiCamera" className="text-lg" /> 
            <span>Uplink Meda</span>
          </button>
        </div>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {photoMoments.map((photo, idx) => (
          <motion.div 
            key={photo.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: idx * 0.05 }}
            className="group relative bg-white rounded-[2.5rem] overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-white"
          >
            <div className="aspect-[4/5] overflow-hidden relative">
              {/* Image with CSS Fallback */}
              <div className="absolute inset-0 bg-[#F5EFE6] flex items-center justify-center text-[#0047AB]/20">
                <SafeIcon icon="FiImage" className="text-6xl" />
              </div>
              <img 
                src={photo.url} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 relative z-10" 
                alt={photo.caption}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity z-20 pointer-events-none" />
            </div>
            <div className="p-6 relative">
              <div className="flex justify-between items-start mb-2">
                <h3 className="font-black text-slate-800 text-sm leading-tight tracking-tight">{photo.caption}</h3>
                <span className="text-[10px] font-black text-slate-300 uppercase tracking-tighter whitespace-nowrap ml-4">{photo.date}</span>
              </div>
              <div className="flex gap-2 mt-6 opacity-0 group-hover:opacity-100 transition-all translate-y-4 group-hover:translate-y-0 duration-300">
                <button className="flex-1 py-2.5 bg-[#F5EFE6] text-[#0047AB] text-[10px] font-black rounded-xl uppercase tracking-widest hover:bg-[#0047AB] hover:text-white transition-colors">Share</button>
                <button className="p-2.5 bg-slate-50 text-slate-400 rounded-xl hover:bg-red-50 hover:text-red-500 transition-colors">
                  <SafeIcon icon="FiHeart" />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}